import { createContext, useContext } from 'react';
import { WizardPageContext } from '..';

export const PageContext = createContext<WizardPageContext>({
  onComplete: () => {},
  onLoad: () => {},
});

export const usePage = () => {
  return useContext(PageContext);
};
